import api from '../../api'
import { takeLatest, takeEvery, call, put, select, all } from 'redux-saga/effects'
import {
    areCampaignsFetched,
    areOrganizationsFetched, selectActiveOrganizationId,
    selectFeedById,
} from "./selectors";
import {
    fetchAdLabelsByOrganizationIdAsyncActions,
    fetchAudiUsersAsyncActions,
    fetchCampaignsByOrganizationIdAsyncActions,
    fetchFeedPreviewAsyncActions,
    fetchFeedsByOrganizationIdAsyncActions,
    fetchForecastsAsyncActions, fetchOrganizationsAsyncActions,
    filterAdsAsyncActions,
    setActiveCampaignIdsAction,
    setActiveOrganizationIdAction,
    setActiveOrganizationIdWithActiveCampaignIdAction,
} from "./actions";
import {
    loadFeedsAsyncActions,
} from "../feed/actions"
import {
    IFeed,
    FeedType,
} from "../feed/types"
import { Profile } from "./types";

function* fetchOrganizationsSaga() {
    try {
        // @ts-ignore
        const response = yield call(api.get, '/api/get?url=https://api.remerge.io/organizations');
        if (response) {
            yield put(fetchOrganizationsAsyncActions.success({ organizations: response.data.organizations }))
        }
    } catch (e: any) {
        yield put(fetchOrganizationsAsyncActions.failure({ error: e }))
    }

}

function* fetchCampaignsByOrganizationIdSaga(action: ReturnType<typeof fetchCampaignsByOrganizationIdAsyncActions.request>) {
    try {
        // @ts-ignore
        const response = yield call(api.get, `/api/get?url=https://api.remerge.io/campaigns?organization_id=${action.payload.organizationId}`);
        if (response) {
            yield put(fetchCampaignsByOrganizationIdAsyncActions.success({
                campaigns: response.data.campaigns,
                organizationId: action.payload.organizationId
            }))
        }
    } catch (e: any) {
        yield put(fetchCampaignsByOrganizationIdAsyncActions.failure({ error: e }))
    }
}

function* fetchAdLabelsByOrganizationIdSaga(action: ReturnType<typeof fetchAdLabelsByOrganizationIdAsyncActions.request>) {
    try {
        // @ts-ignore
        const response = yield call(api.get, `/api/get?url=https://api.remerge.io/ad_labels?organization_id=${action.payload.organizationId}`);
        if (response) {
            yield put(fetchAdLabelsByOrganizationIdAsyncActions.success({
                adLabels: response.data.ad_labels,
                organizationId: action.payload.organizationId
            }))
        }
    } catch (e: any) {
        yield put(fetchAdLabelsByOrganizationIdAsyncActions.failure({ error: e }))
    }
}

function* fetchFeedsByOrganizationIdSaga(action: ReturnType<typeof fetchFeedsByOrganizationIdAsyncActions.request>) {
    try {
        // @ts-ignore
        const response = yield call(api.get, `/api/get?url=https://api.remerge.io/feeds?organization_id=${action.payload.organizationId}`);
        if (response) {
            yield put(fetchFeedsByOrganizationIdAsyncActions.success({
                feeds: response.data.feeds, organizationId: action.payload.organizationId
            }));
            const effects = response.data.feeds.map((item: IFeed) => {
                return put(fetchFeedPreviewAsyncActions.request({ feedId: item.id }))
            });
            yield all(effects)
        }
    } catch (e: any) {
        yield put(fetchFeedsByOrganizationIdAsyncActions.failure({ error: e }))
    }
}

function* fetchFeedsPreviewSaga(action: ReturnType<typeof fetchFeedPreviewAsyncActions.request>) {
    try {
        let url = encodeURIComponent(`https://api.remerge.io/feeds/${action.payload.feedId}/preview`);
        // @ts-ignore
        const response = yield call(api.get, `/api/get?url=${url}`);
        if (response) {
            yield put(fetchFeedPreviewAsyncActions.success({
                preview: response.data, feedId: action.payload.feedId
            }));

            // @ts-ignore
            const feed = yield select(selectFeedById, action.payload.feedId);
            yield put(loadFeedsAsyncActions.success({
                feeds: { byId: { [action.payload.feedId]: feed } },
                feedType: FeedType.LIVE
            }))
        }
    } catch (e: any) {
        yield put(fetchFeedPreviewAsyncActions.failure({ error: e }))
    }
}

function* fetchForecastsSaga(action: ReturnType<typeof fetchForecastsAsyncActions.request>) {
    if (action.payload.campaignId === "") {
        return
    }
    try {
        // @ts-ignore
        const response = yield call(api.post, `/api/post?url=https://api.remerge.io/forecasts`, {
            "data": {
                "type": "forecast",
                "attributes": {
                    "campaign_id": action.payload.campaignId,
                    "include_user_ids": true
                }
            }
        });
        if (response) {
            if (!!response.data.data && !!response.data.data.attributes && !!response.data.data.attributes.sample_user_ids) {
                const sampleUsers = {
                    id: action.payload.campaignId,
                    sample_user_ids: response.data.data.attributes.sample_user_ids
                };
                yield put(fetchForecastsAsyncActions.success({
                    sampleUsers: [sampleUsers]
                }));
                yield put(fetchAudiUsersAsyncActions.request({
                    ids: sampleUsers.sample_user_ids
                }))
            }

        }
    } catch (e: any) {
        yield put(fetchForecastsAsyncActions.failure({ error: e }))
    }
}

function* fetchAudiUsersSaga(action: ReturnType<typeof fetchAudiUsersAsyncActions.request>) {
    if (action.payload.ids.length === 0) {
        return
    }
    try {
        let ids = "ids[]=" + action.payload.ids.join("&ids[]=");
        let url = encodeURIComponent(`https://api.remerge.io/audi_users?${ids}`);
        // @ts-ignore
        const response = yield call(api.get, `/api/get?url=${url}`);
        if (response) {
            if (!!response.data.audi_users) {
                const profiles = response.data.audi_users.map((item: any) => {
                    let profile: Profile = {
                        id: "",
                        audiences: {
                            byId: {},
                        }
                    };
                    if (!!item.profile.gaid) {
                        profile.id = item.profile.gaid
                    } else if (!!item.profile.idfa) {
                        profile["id"] = item.profile.idfa
                    }
                    if (!!item.profile.audiences) {
                        profile.audiences = {
                            byId: item.profile.audiences,
                        }
                    }
                    return profile
                });
                yield put(fetchAudiUsersAsyncActions.success({
                    profiles: profiles
                }))
            }

        }
    } catch (e: any) {
        yield put(fetchAudiUsersAsyncActions.failure({ error: e }))
    }
}

function* filterAdsSaga(action: ReturnType<typeof filterAdsAsyncActions.request>) {
    // https://api.remerge.io/ads?campaign_ids%5B%5D=18125&organization_id=491&status=1
    const campaignIds = action.payload.campaignIds.join("&campaign_ids[]=");
    try {
        let url = encodeURIComponent(`https://api.remerge.io/ads?campaign_ids[]=${campaignIds}&organization_id=${action.payload.organizationId}&status=${action.payload.status}`);
        // @ts-ignore
        const response = yield call(api.get, `/api/get?url=${url}`);
        if (response) {
            yield put(filterAdsAsyncActions.success({ ads: response.data.ads }))
        }
    } catch (e: any) {
        yield put(filterAdsAsyncActions.failure({ error: e }))
    }
}

function* setActiveOrganizationIdWithActiveCampaignIdSaga(action: ReturnType<typeof setActiveOrganizationIdWithActiveCampaignIdAction>) {
    yield put(setActiveOrganizationIdAction({ organizationId: action.payload.organizationId }));
    yield put(setActiveCampaignIdsAction({ campaignIds: [action.payload.campaignId] }))
}

function* setActiveOrganizationIdSaga(action: ReturnType<typeof setActiveOrganizationIdAction>) {
    const { organizationId } = action.payload;
    if (organizationId === "") {
        return
    }
    // @ts-ignore
    const havingOrgs = yield select(areOrganizationsFetched);
    if (!havingOrgs) {
        yield call(fetchOrganizationsSaga)
    }

    yield all(
        [
            put(fetchCampaignsByOrganizationIdAsyncActions.request({ organizationId: organizationId })),
            put(fetchAdLabelsByOrganizationIdAsyncActions.request({ organizationId: organizationId })),
            put(fetchFeedsByOrganizationIdAsyncActions.request({ organizationId: organizationId })),
        ]
    )
}

function* setActiveCampaignIdsSaga(action: ReturnType<typeof setActiveCampaignIdsAction>) {
    const { campaignIds } = action.payload;
    if (campaignIds && campaignIds.length === 0) {
        return
    }

    // @ts-ignore
    const activeOrgId = yield select(selectActiveOrganizationId);
    if (activeOrgId === "") {
        return
    }

    // @ts-ignore
    const havingCampaigns = yield select(areCampaignsFetched);
    if (!havingCampaigns) {
        yield put(fetchCampaignsByOrganizationIdAsyncActions.request({ organizationId: activeOrgId }))
    }
    yield all(
        [
            put(filterAdsAsyncActions.request({ organizationId: activeOrgId, campaignIds: campaignIds, status: "1" })),
            // put(fetchForecastsAsyncActions.request({campaignId: campaignIds[0]})),
        ]
    )

}

function* organizationActionWatcher() {
    yield takeLatest(fetchOrganizationsAsyncActions.request, fetchOrganizationsSaga);
    yield takeLatest(fetchCampaignsByOrganizationIdAsyncActions.request, fetchCampaignsByOrganizationIdSaga);
    yield takeLatest(fetchAdLabelsByOrganizationIdAsyncActions.request, fetchAdLabelsByOrganizationIdSaga);
    yield takeLatest(fetchFeedsByOrganizationIdAsyncActions.request, fetchFeedsByOrganizationIdSaga);
    yield takeEvery(fetchFeedPreviewAsyncActions.request, fetchFeedsPreviewSaga);
    yield takeLatest(fetchForecastsAsyncActions.request, fetchForecastsSaga);
    yield takeLatest(fetchAudiUsersAsyncActions.request, fetchAudiUsersSaga);
    yield takeLatest(filterAdsAsyncActions.request, filterAdsSaga);
    yield takeLatest(setActiveOrganizationIdWithActiveCampaignIdAction, setActiveOrganizationIdWithActiveCampaignIdSaga);
    yield takeLatest(setActiveOrganizationIdAction, setActiveOrganizationIdSaga);
    yield takeLatest(setActiveCampaignIdsAction, setActiveCampaignIdsSaga)
}

export default organizationActionWatcher;
